import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { VimeoPlayer } from "@up/ui";
import { ClientErrorBoundary } from "~/components/ClientErrorBoundary";
import Testimonials from "~/components/Testimonials/index";
import RichText from "~/components/RichText";
import Wrapper from "~/components/SliceWrapper";

/**
 * Props for `Testimonial`.
 */
export type TestimonialProps = SliceComponentProps<Content.TestimonialSlice>;

/**
 * Component for "Testimonial" Slices.
 */
const Testimonial: FC<TestimonialProps> = ({ slice }) => {
  const primary = slice.primary as Record<string, any>;

  return (
    <ClientErrorBoundary message="Testimonial slice error boundary">
      {/* @ts-expect-error — SliceWrapper is an untyped JS component */}
      <Wrapper data-analytics-component="testimonial" slice={slice}>
        {primary.heading && (
          <div className="rte section-heading">
            <RichText field={primary.heading} />
          </div>
        )}
        {primary.video_id && (
          <div
            className="video-player-wrapper"
            style={{
              marginRight: "auto",
              marginBottom: "3rem",
              marginLeft: "auto",
            }}
          >
            <div className="responsive-video">
              <VimeoPlayer
                autoplay={false}
                id={primary.video_id}
                shouldLoad={true}
              />
            </div>
          </div>
        )}
        <Testimonials items={slice.primary.testimonials} />
      </Wrapper>
    </ClientErrorBoundary>
  );
};

export default Testimonial;
